module.exports = __webpack_public_path__ + "media/images/how-img-1024-2f8dd84fd62a63d68e3cda070d2f783c.svg";